export function isMobile(){
    return /Android|iPhone|iPad/i.test(navigator.userAgent);
}